import { routerRedux } from 'dva';
import { login, logout } from '../service';
import $$ from 'cmn-utils';

export default {
    namespace: 'login',

    state: {
        loggedIn: false,
        msg: '',
        user: {}
    },

    subscriptions: {
        setup({ history, dispatch }) {
            return history.listen(({ pathname }) => {
                if (pathname.indexOf('/sign/login') !== -1) {
                    $$.store.session('user', "");
                    $$.store.session('session_id', "");
                }
            });
        }
    },

    effects: {
        *login({ payload }, { call, put }) {
            try {
                const { code, msg, data, session_id } = yield call(login, payload);
                if (code == 0) {
                    $$.store.session('user', data);
                    $$.store.session('session_id', session_id);
                    //yield put(routerRedux.replace('/'));
                    yield put({
                        type: 'loginSuccess',
                        payload: data
                    });

                    yield put(routerRedux.replace('/'));

                    return true;
                } else {
                    yield put({
                        type: 'loginError',
                        payload: { msg }
                    });

                    return false;
                }
            } catch (e) {
                console.log(e)
                yield put({
                    type: 'loginError',
                    payload: { msg: e.message }
                });

                return false;
            }
        }
    },

    reducers: {
        loginSuccess(state, { payload }) {
            return {
                ...state,
                loggedIn: true,
                msg: '',
                user: payload
            };
        },
        loginError(state, { payload }) {
            return {
                ...state,
                loggedIn: false,
                msg: payload.msg
            };
        }
    }
};
